import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { store } from "./components/Redux/Store";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { LoadProvider } from "./components/ReusableComponents/LoadingContex";
// Datadog imports
// import { datadogRum } from "@datadog/browser-rum";
// import { reactPlugin } from "@datadog/browser-rum-react";

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));

// datadogRum.init({
//   applicationId: "95b530af-7aff-4e70-ba78-045df4e25fce",
//   clientToken: "pub5960f3d0d0623f8904d8b64d6cc7a64e",
//   site: "us3.datadoghq.com",
//   service: "uat-rum",
//   env: "uat",
//   // Specify a version number to identify the deployed version of your application in Datadog
//   // version: '1.0.0',
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 20,
//   defaultPrivacyLevel: "mask-user-input",
//   plugins: [reactPlugin({ router: true })],
// });

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <LoadProvider>
        <App />
      </LoadProvider>
    </PersistGate>
  </Provider>
  //  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
